import { useAuthInterface } from '@/composables/useAuthInterface';
import Cookies from 'js-cookie';

export const useFlutter = store => {
  function sendDataToFlutter(
    { level, message } = { level: 'D', message: 'SPA: logToFlutter called without data' }
  ) {
    if (
      window.flutter_inappwebview &&
      typeof window.flutter_inappwebview.callHandler === 'function'
    ) {
      window.flutter_inappwebview.callHandler('log', { level, message });
    } else {
      store.$log('$logToFlutter', level, message);
    }
  }

  const logToFlutter = data => {
    if (!store.state.general.isMobileApp) {
      return;
    }

    const flutterState = store.state.flutter;
    if (flutterState.isFlutterReady) {
      while (flutterState.flutterQueue.length) {
        sendDataToFlutter(flutterState.flutterQueue[0]);
        store.dispatch('flutter/shiftFlutterQueue');
      }
      sendDataToFlutter(data);
    } else {
      store.dispatch('flutter/addFlutterQueue', data);
    }
  };

  const setupBridge = () => {
    if (!window.flutter_inappwebview) {
      return false;
    }

    const $auth = useAuthInterface(store);

    // If no token was found during boot, the router guard must wait for
    // Flutter to inject tokens via mobileAuth before making auth decisions.
    let resolveMobileAuth;
    if (!store.state.auth.isBusy && !store.state.auth.isLoggedIn) {
      const mobileAuthPromise = new Promise(resolve => {
        resolveMobileAuth = resolve;
      });
      // Safety timeout — proceed even if Flutter never calls mobileAuth
      const timeout = setTimeout(resolveMobileAuth, 10000);
      store.$authReady = mobileAuthPromise.then(() => clearTimeout(timeout));
    }

    window.mobileAuth = (accessToken, refreshToken, isFirstTimeLogin) => {
      try {
        $auth.onLoginSuccess({ accessToken, refreshToken, tokenType: 'Bearer' }).then(() => {
          if (isFirstTimeLogin) {
            store.commit('auth/setFirstTimeNativeLogin', true);
          }

          if (resolveMobileAuth) {
            resolveMobileAuth();
          }

          logToFlutter({
            level: 'D',
            message: 'SPA: in mobileAuth after setUserToken'
          });

          window.flutter_inappwebview.callHandler('onMobileAuth');
        });
      } catch (err) {
        console.error('mobileAuth error', err);
      }

      return true;
    };

    window.setCookiesFromFlutter = cookies => {
      logToFlutter({
        level: 'D',
        message: `SPA: setCookiesFromFlutter: ${JSON.stringify(cookies)}`
      });

      Cookies.set('cookies-consent-granted', new Date().valueOf(), { expires: 365 });
      for (const cookieKey of Object.keys(cookies)) {
        Cookies.set(`cookie-preference_${cookieKey}`, cookies[cookieKey] === true ? 'yes' : 'no', {
          expires: 365
        });
      }

      return Cookies.get('cookies-consent-granted');
    };

    window.flutter_inappwebview.callHandler('onSpaReady');
  };

  return { logToFlutter, setupBridge };
};
